<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div style="display: flex; justify-content: start">
        <div class="commonText">合集名稱：</div>
        <div class="commonText" style="max-width: 700px; text-align: left">
          {{ row.title }}
        </div>
        <div class="commonText" style="margin-left: 50px">
          合集數量：共{{ total }}集
        </div>
      </div>
      <div style="display: flex; justify-content: start; margin-top: 20px">
        <div class="commonText">創建時間：{{ row.createTime }}</div>
      </div>
      <div class="MenuBtnWrap">
        <div
          class="btn"
          @click="$router.push('addCollection?soulId=' + row.id)"
        >
          新增
        </div>
      </div>
      <div class="tableWrap">
        <el-table
          :data="singleSongList"
          height="660px"
          stripe
          style="width: 100%"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in singleSongTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'playCount'">
                {{ scope.row[item.prop] }}
                <i @click="changePlayerNum(scope.row)" class="el-icon-edit"></i>
              </div>
              <div v-else-if="item.prop == 'vodType'">
                {{ scope.row.vodType == 1 ? "視頻" : "音頻" }}
              </div>
              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="詳情" fixed="right" :width="180">
            <template slot-scope="scope">
              <el-button class="topBtn" @click="goEdit(scope.row)" type="text"
                >編輯
              </el-button>
              <el-button
                type="text"
                @click="viewComments(scope.row.id)"
                :disabled="scope.row.status == '待發佈'"
                >查看評論</el-button
              >
              <el-button @click="goDel(scope.row.id)" type="text"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { throttle } from "../../directives/limit";
export default {
  data() {
    return {
      navBlock: "靈魂的共鳴 / 合集列表",
      navtitle: "詳情",
      singleSongList: [],
      showMoadl: false,
      introduceFlag: "cn",
      copyrightFlag: "cn",
      row: JSON.parse(decodeURIComponent(this.$route.query.row)),
      singleSongTable: [
        {
          prop: "name",
          label: "單集名稱",
          width: "500px",
        },
        {
          prop: "vodType",
          label: "類型",
        },
        {
          prop: "duration",
          label: "播放時長",
        },
        {
          prop: "playCount",
          label: "播放量",
        },
        {
          prop: "status",
          label: "發佈狀態",
        },
        {
          prop: "publishTime",
          label: "發佈時間",
        },
      ],
      currentPage: 1,
      total: 0,
      showNoneTips: false,
      dialogVisible: false,
      fileList: [],
    };
  },
  created() {
    this.getList();
  },

  methods: {
    //查看评论
    viewComments(id) {
      this.$router.push(`/collectionComment?id=${id}`);
    },
    // 获取合集列表
    getList() {
      this.$get(
        `/request/soul/resonance/song/list?page=${this.currentPage}&size=10&id=${this.row.id}`,
        {},
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code === "00000") {
          res.data.list.forEach((v) => {
            v.publishTime = this.$getTime(v.publishTime);
            v.status = v.status == 1 ? "已發佈" : "待發佈";
          });
          this.singleSongList = res.data.list;
          this.total = res.data.allRow;
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        const fileWay = "resource/image/";
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then((client) => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client
            .multipartUpload(fileName, file, {
              headers: { "Cache-Control": "public" },
            })
            .then(
              (val) => {
                if (val.res.statusCode === 200) {
                  self.fileList.push({
                    name: "img.jpg",
                    url: self.$GLOBAL.picFileUrl + val.name,
                  });
                  console.log("图片路径++" + self.fileList[0].url);
                  //cdn预热
                  self.$cdnFun(self.fileList[0].url).then((res) => {
                    console.log(res);
                    self.form.img = self.fileList[0].url;
                  });
                  document.getElementsByClassName(
                    "el-upload"
                  )[0].style.display = "none";
                  return val;
                } else {
                  option.onError("上传失败");
                }
              },
              (err) => {
                console.log(err);
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    // 移除图片的回调函数
    handleRemove(file, fileList) {
      this.$deleteUidItem(file.uid, this.fileList);
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
    },
    // 上传列表发生变化的回调函数
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    submitContent() {
      this.$post(
        `/request/soul/resonance/collection/operate`,
        this.form,
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code === "00000") {
          this.$propMessage("创建成功", "success");
          this.form = {};
          this.titleFlag = "cn";
          this.introduceFlag = "cn";
          this.copyrightFlag = "cn";
          this.showMoadl = false;
          this.getList();
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    //删除

    goDel: throttle(
      function () {
        return true;
      },
      function (id) {
        this.$message.closeAll();
        this.$confirm("是否刪除該單集？刪除後將無法恢復", "刪除合集", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
        })
          .then(() => {
            this.$post(
              `/request/soul/resonance/song/delete`,
              { id, soulId: this.row.id },
              this.$GLOBAL.jsonConfig
            ).then((res) => {
              if (res.code === "00000") {
                this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 2000,
                });
                this.getList();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            });
          })
          .catch(() => {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
            // this.$propMessage("已取消删除", "info");
          });
      },
      2000
    ),
    //编辑
    goEdit(e) {
      //过滤掉e里面collectionTotal，playTotal等属性之后在赋值
      this.form = { ...e };
      delete this.form.playCount;
      delete this.form.soulId;
      this.$router.push(
        "addCollection?soulId=" +
          this.row.id +
          "&row=" +
          encodeURIComponent(JSON.stringify(this.form))
      );
    },
    // 修改播放数量
    changePlayerNum(row) {
      this.$prompt("修改播放量：", "", {
        inputValue: row.playCount,
        inputPlaceholder: "請輸入播放量",
        confirmButtonText: "修改",
        cancelButtonText: "取消",
        showClose: false,
        center: false,
        closeOnClickModal: false,
        inputValidator: (value) => {
          if (!/^\d*$/.test(value)) {
            return "播放量只能為純數字，且不能為負數";
          }
        },
        // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        if (!value) {
          this.$message({
            message: "請輸入播放量",
            type: "error",
            center: true,
          });
          return;
        }
        if (value > 999999) {
          this.$message({
            message: "播放量不能大於999999",
            type: "error",
            center: true,
          });
          return;
        }
        let params = {
          id: row.id,
          playCount: value,
        };
        this.$post(
          "/request/soul/resonance/song/play/count",
          params,
          this.$GLOBAL.jsonConfig
        ).then((res) => {
          // console.log(res)
          if (res.code === "00000") {
            this.$message({
              message: "修改成功",
              type: "success",
              center: true,
            });
            this.getList();
          } else {
            this.$message({
              message: res.message,
              type: "error",
              center: true,
            });
          }
        });
      });
    },
  },
  components: {
    NavBar,
    DiaMess,
  },
};
</script>
<style lang="less" scoped>
.box_flex {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.box_input {
  width: 200px;
  margin-left: 20px;
}
.box_text {
  font-size: 14px;
}
.label_text {
  font-size: 14px;
  cursor: pointer;
}
.commonText {
  font-size: 14px;
  color: #000000;
}
/deep/.el-textarea__inner {
  line-height: 14px !important;
  height: 130px;
}
</style>



// WEBPACK FOOTER //
// src/pages/jjsoul/collectionDetail.vue